import MainLayout from 'components/Modules/Layout/MainLayout';

export default function BillOfLadingDetailPage(): JSX.Element {
  return <MainLayout>halo</MainLayout>;
}
